import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import { HelperService } from '../helper/helper.service';
import {
  fetchGroupDetails,
  fetchLastUpdates,
  fetchTopBanners,
} from '../../store/dashboard/dashboard.actions';
import { Observable } from 'rxjs';
import {IDashboardState, IState} from '@models/index';
import {
  getDashboardsGroupDetailSelector,
  getDashboardsLastUpdatesSelector,
  getDashboardsSelector
} from '@store/dashboard/dashboard.selectors';
import {IGroupDetails} from '@interfaces/index';
import {StoreModel} from '@interfaces/IStoreModel';

@Injectable({
  providedIn: "root"
})
export class DashboardService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ dashboard: any }>
  ) {}

  selectDashboardStore(): Observable<IDashboardState> {
    return this.store.select(getDashboardsSelector);
  }

  selectLastUpdates(): Observable<StoreModel<IState>> {
    return this.store.select(getDashboardsLastUpdatesSelector);
  }

  selectGroupDetails(): Observable<StoreModel<IGroupDetails>> {
    return this.store.select(getDashboardsGroupDetailSelector);
  }

  fetchTopBanners(): void {
    this.store.dispatch(fetchTopBanners());
  }

  fetchGroupDetails(params?: {}): void {
    this.store.dispatch(fetchGroupDetails({payload: params}));
  }

  getTopBanners() {
    // const queryparams = { ...{ page }, ...filterOptions };
    // const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/reports/top-banners`);
  }

  fetchLastUpdates(): void {
    this.store.dispatch(fetchLastUpdates());
  }

  getLastUpdates() {
    return this.http.get(`${this.backendUrl}/reports/last-updates`);
  }

  getGroupDetails() {
    return this.http.get(`${this.backendUrl}/reports/group-affiliate`);
  }

}

